import { useEffect, useState } from "react";
import { Link } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";

const STORAGE_KEY = "oms-cookie-consent";

export function CookieBanner() {
  const [visible, setVisible] = useState(false);
  const { t } = useTranslation();

  useEffect(() => {
    if (typeof window === "undefined") return;
    const check = () => {
      const v = localStorage.getItem(STORAGE_KEY);
      setVisible(v !== "accepted" && v !== "declined");
    };
    check();
    window.addEventListener("oms-cookie-consent-change", check);
    return () => window.removeEventListener("oms-cookie-consent-change", check);
  }, []);

  if (!visible) return null;

  const set = (value: "accepted" | "declined") => {
    localStorage.setItem(STORAGE_KEY, value);
    setVisible(false);
    window.dispatchEvent(new Event("oms-cookie-consent-change"));
  };

  return (
    <div className="fixed inset-x-3 bottom-3 z-50 md:inset-x-auto md:right-5 md:bottom-5 md:max-w-md">
      <div className="rounded border border-border bg-background/95 backdrop-blur p-5 shadow-lg">
        <div className="serif text-lg mb-1">{t("cookies.title")}</div>
        <p className="text-xs text-muted-foreground leading-relaxed">
          {t("cookies.body")}{" "}
          <Link to="/datenschutz" className="underline">{t("cookies.privacyLink")}</Link>.
        </p>
        <div className="mt-4 flex flex-wrap gap-2">
          <button
            onClick={() => set("accepted")}
            className="rounded bg-primary px-3 py-1.5 text-xs font-medium text-primary-foreground hover:bg-primary/90"
          >
            {t("cookies.accept")}
          </button>
          <button
            onClick={() => set("declined")}
            className="rounded border border-input bg-background px-3 py-1.5 text-xs font-medium hover:bg-accent"
          >
            {t("cookies.decline")}
          </button>
          <Link
            to="/cookies"
            className="rounded px-3 py-1.5 text-xs text-muted-foreground hover:text-foreground"
          >
            {t("cookies.settings")}
          </Link>
        </div>
      </div>
    </div>
  );
}